'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.ADD_CONTENT = exports.REMOVE_SIMILAR_TITLE = exports.ADD_SIMILAR_TITLE = exports.SIMILAR_TITLES = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIMILAR_TITLES = _constantsAnalytics2.default.CATEGORIES.SIMILAR_TITLES;
exports.SIMILAR_TITLES = SIMILAR_TITLES;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_SIMILAR_TITLE = _analyticsConstants$E.ADD_SIMILAR_TITLE,
    REMOVE_SIMILAR_TITLE = _analyticsConstants$E.REMOVE_SIMILAR_TITLE;
exports.ADD_SIMILAR_TITLE = ADD_SIMILAR_TITLE;
exports.REMOVE_SIMILAR_TITLE = REMOVE_SIMILAR_TITLE;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
exports.ADD_CONTENT = ADD_CONTENT;
exports.REMOVE_CONTENT = REMOVE_CONTENT;


function composeSimilarTitlesEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: SIMILAR_TITLES,
    gtmAction: action
  });
}

function composeAddSimilarTitlesEvent() {
  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(ADD_SIMILAR_TITLE, ADD_CONTENT)]);
}

function composeRemoveSimilarTitlesEvent() {
  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(REMOVE_SIMILAR_TITLE, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddSimilarTitlesEvent: composeAddSimilarTitlesEvent,
  composeRemoveSimilarTitlesEvent: composeRemoveSimilarTitlesEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/similarTitlesEventComposer.js
// module id = 587
// module chunks = 0 2 4 5 6 8 9 10 11